import { get } from "services/httpService";

const SERVICE_URLS = {
  getStrategiesList: () => `marketplace/`,
  getLabelCount: (qs) => `marketplace/strategy-label-count${qs}`,
};

export const getLabelCount = (slug) => {
  let queryString = null;
  if (slug) {
    queryString = `?card_collection=${slug}`;
  }
  return get(SERVICE_URLS.getLabelCount(queryString || ""));
};

export const getStrategiesList = (params) => {
  return get(SERVICE_URLS.getStrategiesList(), params);
};
